import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListHLSTranscoderObject from '../../components/content/list-hls-transcoder-object.component';

const HLSTranscoderObjectView = () => {
  const pageTitle = 'Encode Videos / HLS Encoder (Object Storage)';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListHLSTranscoderObject />
    </AppLayout>
  );
};

export default HLSTranscoderObjectView;
